import React, { useState } from "react";
import "./Login.css";
import { Form, Input, Button, Flex, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Mail } from "../../assets/mail.svg";
import { forgetpassword } from "../../services/ApiService";
import { LoadingOutlined } from "@ant-design/icons";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);
    try {
      const res = await forgetpassword(values);
      if (res.responseCode === 200) {
        message.success(res.responseMessage);
        sessionStorage.setItem("email", values.email);
        navigate("/verify-email", { state: { text: "Email Verification" } });
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      message.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleCode = () => {
    form
      .validateFields()
      .then(onFinish)
      .catch((errorInfo) => {
        const errorMessage =
          errorInfo.errorFields?.[0]?.errors?.[0] ||
          "Please enter a valid email.";
        message.error(errorMessage);
      });
  };

  const handleFormChange = async () => {
    try {
      await form.validateFields();
      setIsFormValid(true);
    } catch (errors) {
      if (errors.errorFields && errors.errorFields.length > 0)
        setIsFormValid(false);
      else setIsFormValid(true);
    }
  };

  return (
    <>
      <div className="main-container">
        <div>
          <Form
            form={form}
            name="login"
            initialValues={{ remember: true }}
            layout="vertical"
            style={{ marginTop: "1.3rem" }}
            onValuesChange={handleFormChange}
            onFinish={handleCode}
          >
            <div className="login">
              <h4 className="title">Forgot Password</h4>
              <div className="desc">
                Enter the email address associated with your account and we'll
                send you a code to reset your password.
              </div>

              <Form.Item
                name="email"
                label={<span className="input-label">Email</span>}
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "The input is not a valid email!",
                  },
                ]}
                colon={false}
              >
                <Input
                  aria-label="Email address"
                  className="input"
                  prefix={<Mail style={{ marginRight: "8px" }} />}
                  placeholder="Email address"
                />
              </Form.Item>
            </div>
            <Flex justify="flex-end" className="login-btn">
              <Button
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={!isFormValid || loader}
                style={{
                  padding: "1.2rem",
                  backgroundColor: "#4A3AFF",
                }}
              >
                Get Verification Code
                {loader && <LoadingOutlined style={{ color: "white" }} />}
              </Button>
            </Flex>
          </Form>
        </div>
        <div className="copyright">
          Copyright © 2026 Procloz Services Pvt Ltd | All Rights Reserved
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
